import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { FilterYear } from '../../../components/Reports/FilterYear';
import { FilterReportYearData } from '../../../components/Reports/Filter';
import { ReportInspectionPlanForInspectedProductType } from '../../../../common/types/ReportTypes';
import { ReportInspectionPlanByInspectedProduct } from '../../../components/ReportInspectionPlanByOrganization/ReportInspectionPlanByInspectedProduct';

export const ReportInspectionPlanByInspectedProductView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<
    FilterReportYearData | undefined
  >({});
  const [data, setData] =
    useState<ReportInspectionPlanForInspectedProductType>();

  const onSearch = (filter?: FilterReportYearData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportInspectionPlanByInspectedProduct(filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <FilterYear
        onSearch={onSearch}
        reportName="Wykonanie planu - liczba skontrolowanych wyrobów"
      />
      <ReportInspectionPlanByInspectedProduct
        data={data}
        reportName="Wykonanie planu w zakresie liczby skontrolowanych wyrobów"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
      />
    </>
  );
};
